import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { useAuth } from '../auth';
import { Role } from '../types';

export function RoleGate({ allow, children }: { allow: Role[]; children: ReactNode }) {
  const { hasRole } = useAuth();
  if (!hasRole(...allow)) {
    return (
      <Box sx={{ p: 4 }}>
        <Typography variant="h4">Access denied</Typography>
        <Typography variant="body1" sx={{ mt: 1, color: 'text.secondary' }}>
          You don't have permission to view this page.
        </Typography>
      </Box>
    );
  }
  return <>{children}</>;
}
